/**
 * Generated from ResultsScreenLayout.fla
 */
export function ResultsScreenLayout(this: IResultsScreenLayout) {
	const characters = this.characters;
	if (!characters[0] && characters.elementFactory) {
		characters[0] = characters.elementFactory(0,undefined);
	}
	if (characters[0]) {
		ResultsScreenLayout_inez.call(characters[0] as IResultsScreenLayout_inez);
		characters[0].x = 245.5;
		characters[0].y = 593.75;
		characters[0].width = 193.00;
		characters[0].height = 241.50;
		if (characters[0].onLayout) characters[0].onLayout();
	}
	if (!characters[1] && characters.elementFactory) {
		characters[1] = characters.elementFactory(1,undefined);
	}
	if (characters[1]) {
		ResultsScreenLayout_jackie.call(characters[1] as IResultsScreenLayout_jackie);
		characters[1].x = 94.45;
		characters[1].y = 496;
		characters[1].width = 193.00;
		characters[1].height = 272.50;
		if (characters[1].onLayout) characters[1].onLayout();
	}
	if (!characters[2] && characters.elementFactory) {
		characters[2] = characters.elementFactory(2,undefined);
	}
	if (characters[2]) {
		ResultsScreenLayout_matt.call(characters[2] as IResultsScreenLayout_matt);
		characters[2].x = 416.5;
		characters[2].y = 500.55;
		characters[2].width = 193.50;
		characters[2].height = 268.50;
		if (characters[2].onLayout) characters[2].onLayout();
	}
	if (!characters[3] && characters.elementFactory) {
		characters[3] = characters.elementFactory(3,undefined);
	}
	if (characters[3]) {
		ResultsScreenLayout_digit.call(characters[3] as IResultsScreenLayout_digit);
		characters[3].x = 491.5;
		characters[3].y = 597.05;
		characters[3].width = 192.87;
		characters[3].height = 209.47;
		if (characters[3].onLayout) characters[3].onLayout();
	}
	const shadow = this.shadow;
	if (!shadow[0] && shadow.elementFactory) {
		shadow[0] = shadow.elementFactory(0,undefined);
	}
	if (shadow[0]) {
		ResultsScreenLayout_shadow.call(shadow[0] as IResultsScreenLayout_shadow);
		shadow[0].x = 241.45;
		shadow[0].y = 743.05;
		shadow[0].width = 97.00;
		shadow[0].height = 19.00;
		if (shadow[0].onLayout) shadow[0].onLayout();
	}
	if (!shadow[1] && shadow.elementFactory) {
		shadow[1] = shadow.elementFactory(1,undefined);
	}
	if (shadow[1]) {
		ResultsScreenLayout_shadow.call(shadow[1] as IResultsScreenLayout_shadow);
		shadow[1].x = 84.4;
		shadow[1].y = 670.55;
		shadow[1].width = 97.00;
		shadow[1].height = 19.00;
		if (shadow[1].onLayout) shadow[1].onLayout();
	}
	if (!shadow[2] && shadow.elementFactory) {
		shadow[2] = shadow.elementFactory(2,undefined);
	}
	if (shadow[2]) {
		ResultsScreenLayout_shadow.call(shadow[2] as IResultsScreenLayout_shadow);
		shadow[2].x = 418;
		shadow[2].y = 670.55;
		shadow[2].width = 97.00;
		shadow[2].height = 19.00;
		if (shadow[2].onLayout) shadow[2].onLayout();
	}
	if (!shadow[3] && shadow.elementFactory) {
		shadow[3] = shadow.elementFactory(3,undefined);
	}
	if (shadow[3]) {
		ResultsScreenLayout_shadow.call(shadow[3] as IResultsScreenLayout_shadow);
		shadow[3].x = 523.5;
		shadow[3].y = 714.55;
		shadow[3].width = 97.00;
		shadow[3].height = 19.00;
		if (shadow[3].onLayout) shadow[3].onLayout();
	}
	const bg = this.bg;
	ResultsScreenLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const banner = this.banner;
	ResultsScreenLayout_banner.call(this.banner);
	banner.x = 513.75;
	banner.y = 150.25;
	banner.width = 919.50;
	banner.height = 192.50;
	if (banner.onLayout) banner.onLayout();
	const nineducks = this.nineducks;
	ResultsScreenLayout_nineducks.call(this.nineducks);
	nineducks.x = 738.25;
	nineducks.y = 560.25;
	nineducks.width = 492.50;
	nineducks.height = 182.50;
	if (nineducks.onLayout) nineducks.onLayout();
	const sevenducks = this.sevenducks;
	ResultsScreenLayout_sevenducks.call(this.sevenducks);
	sevenducks.x = 767.5;
	sevenducks.y = 572.8;
	sevenducks.width = 412.00;
	sevenducks.height = 176.50;
	if (sevenducks.onLayout) sevenducks.onLayout();
	const fiveducks = this.fiveducks;
	ResultsScreenLayout_fiveducks.call(this.fiveducks);
	fiveducks.x = 716.25;
	fiveducks.y = 555;
	fiveducks.width = 348.50;
	fiveducks.height = 160.00;
	if (fiveducks.onLayout) fiveducks.onLayout();
	const buttonfive = this.buttonfive;
	ResultsScreenLayout_buttonfive.call(this.buttonfive);
	buttonfive.x = 181.5;
	buttonfive.y = 279;
	buttonfive.width = 256.80;
	buttonfive.height = 116.40;
	if (buttonfive.onLayout) buttonfive.onLayout();
	const buttonseven = this.buttonseven;
	ResultsScreenLayout_buttonseven.call(this.buttonseven);
	buttonseven.x = 512.5;
	buttonseven.y = 279;
	buttonseven.width = 256.80;
	buttonseven.height = 116.40;
	if (buttonseven.onLayout) buttonseven.onLayout();
	const buttonnine = this.buttonnine;
	ResultsScreenLayout_buttonnine.call(this.buttonnine);
	buttonnine.x = 842.5;
	buttonnine.y = 279;
	buttonnine.width = 256.80;
	buttonnine.height = 116.40;
	if (buttonnine.onLayout) buttonnine.onLayout();
	return this;
}
function ResultsScreenLayout_bg(this: IResultsScreenLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-bg@2x.jpg", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_banner(this: IResultsScreenLayout_banner) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-banner.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_inez(this: IResultsScreenLayout_inez) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-characters-inez.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_jackie(this: IResultsScreenLayout_jackie) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-characters-jackie.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_matt(this: IResultsScreenLayout_matt) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-characters-matt.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_shadow(this: IResultsScreenLayout_shadow) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-characters-shadow.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_nineducks(this: IResultsScreenLayout_nineducks) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-ducks9.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_sevenducks(this: IResultsScreenLayout_sevenducks) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-ducks7.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_fiveducks(this: IResultsScreenLayout_fiveducks) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-results-ducks5.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_digit(this: IResultsScreenLayout_digit) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-intro-characters-digit.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_buttonfive(this: IResultsScreenLayout_buttonfive) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain5.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_buttonseven(this: IResultsScreenLayout_buttonseven) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain7.png", 0.500, 0.500);
	return this;
}
function ResultsScreenLayout_buttonnine(this: IResultsScreenLayout_buttonnine) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain9.png", 0.500, 0.500);
	return this;
}
interface IResultsScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IResultsScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IResultsScreenLayoutSprite extends IResultsScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IResultsScreenLayoutText extends IResultsScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IResultsScreenLayoutPolygon extends Array<number> {
}
interface IResultsScreenLayout {
	readonly characters: IResultsScreenLayoutArray<IResultsScreenLayout_inez|IResultsScreenLayout_jackie|IResultsScreenLayout_matt|IResultsScreenLayout_digit>;
	readonly shadow: IResultsScreenLayoutArray<IResultsScreenLayout_shadow>;
	readonly bg: IResultsScreenLayout_bg;
	readonly banner: IResultsScreenLayout_banner;
	readonly nineducks: IResultsScreenLayout_nineducks;
	readonly sevenducks: IResultsScreenLayout_sevenducks;
	readonly fiveducks: IResultsScreenLayout_fiveducks;
	readonly buttonfive: IResultsScreenLayout_buttonfive;
	readonly buttonseven: IResultsScreenLayout_buttonseven;
	readonly buttonnine: IResultsScreenLayout_buttonnine;
}
interface IResultsScreenLayout_bg extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_banner extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_inez extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_jackie extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_matt extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_shadow extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_nineducks extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_sevenducks extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_fiveducks extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_digit extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_buttonfive extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_buttonseven extends IResultsScreenLayoutSprite {
}
interface IResultsScreenLayout_buttonnine extends IResultsScreenLayoutSprite {
}
